import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import type { ConsumptionEvent } from '../consumption/ConsumptionEvents';

export const useSendAnalyticsEvents = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const sendEvent = useCallback(
		(event: ConsumptionEvent, skipVisibilityCheck = false) => {
			if (document.visibilityState === 'hidden' && !skipVisibilityCheck) {
				document.addEventListener(
					'visibilitychange',
					() => {
						if (document.visibilityState === 'visible') {
							createAnalyticsEvent(event).fire();
						}
					},
					{ once: true },
				);
			} else {
				createAnalyticsEvent(event).fire();
			}
		},
		[createAnalyticsEvent],
	);

	return { sendEvent };
};
